'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {ViewModePropType} from '../../../core-utilities/enums/ViewMode';
import {getItemClass} from '../../../core-utilities/redux/utils';
import {AssetProjectItem} from '../AssetProjectItem';
import {List} from '../../../components/lists/List';


export function AssetProjectListView(props) {
  return (
    <List
      className={classNames("AssetProjectList", props.className)}
      useScroll={props.useScroll}
      flipped={false}
      autoScroll={false}
      mode={props.mode}
      onLoadMore={props.onLoadMore}
      transitionGroupClass={props.transitionGroupClass}
    >
      {props.list ? props.list.map(model => (
        <AssetProjectItem
          key={getId(model)}
          className={classNames(props.itemClassName, getItemClass(model))}
          userId={props.userId}
          model={model}
          onClick={props.onClickItem}
          onContextMenu={props.onItemContextMenu}

          init={props.init}
        />
      )) : null}
    </List>
  );
}

AssetProjectListView.propTypes = {
  transitionGroupClass: T.string,
  itemClassName: T.string,
  userId: T.string.isRequired,
  list: T.array,
  mode: ViewModePropType,

  onClickItem: T.func.isRequired,
  onItemContextMenu: T.func.isRequired,

  init: T.bool,
};

AssetProjectListView.defaultProps = {
  init: true,
};



// WEBPACK FOOTER //
// ./src/js/projects/components/AssetProjectList/AssetProjectListView.js